import React from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import { element, bool, shape, string, func } from 'prop-types';
import { intlShape } from 'react-intl';
import { ANCHOR_CLASS } from './menu';

class MenuWrapper extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  onOpen() {
    if (this.props.floating) {
      const { innerHeight, innerWidth } = window;
      const {
        right,
        bottom,
        left,
        top,
        width,
        height,
      } = this.root.getBoundingClientRect();

      Object.assign(
        this.span.style,
        this.props.top
          ? { top: `${top}px` }
          : { bottom: `${innerHeight - bottom}px` },
        this.props.left
          ? { left: `${left}px` }
          : { right: `${innerWidth - right}px` },
      );

      Object.assign(this.span.style, {
        width: `${width}px`,
        height: `${height}px`,
        display: 'block',
      });
    }
  }

  onClose() {
    if (this.props.floating && this.span) {
      document.body.querySelector('.menus').removeChild(this.span);
      this.span = null;
    }

    this.props.onClose();
  }

  handleClick(e) {
    e.stopPropagation();

    if (!this.props.disabled) {
      if (this.state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  open() {
    if (this.props.floating) {
      this.span = document.createElement('span');
      this.span.classList.add(ANCHOR_CLASS);
      this.span.classList.add('floating');
      document.body.querySelector('.menus').appendChild(this.span);
    }

    this.setState({
      open: true,
    }, this.onOpen);
  }

  close() {
    this.setState({
      open: false,
    }, this.onClose);
  }

  renderFloatingMenu() {
    return this.root && this.span && createPortal(
      this.renderMenu(),
      this.span,
    );
  }

  renderMenu() {
    const { open } = this.state;
    const {
      children,
      wrappedElement,
      floating,
      ...props
    } = this.props;

    return React.cloneElement(
      React.Children.only(children),
      {
        open,
        onCancel: this.close,
        onSelect: this.close,
        ...props,
      },
    );
  }

  render() {
    const { wrappedElement, floating, className, disabled } = this.props;
    const { open } = this.state;

    return (
      <span
        tabIndex="0"
        role="button"
        className={classnames(
          'menu-wrapper',
          className,
          {
            [ANCHOR_CLASS]: !floating,
            active: open,
            disabled,
          },
        )}
        ref={(cmp) => { this.root = cmp; }}
        onClick={this.handleClick}
      >
        {React.Children.only(wrappedElement)}
        {floating
          ? this.renderFloatingMenu()
          : this.renderMenu()
        }
      </span>
    );
  }
}

MenuWrapper.propTypes = {
  children: element.isRequired,
  wrappedElement: element.isRequired,
  floating: bool,
  top: bool,
  left: bool,
  disabled: bool,
  className: string,
  onClose: func,
};

MenuWrapper.defaultProps = {
  floating: false,
  disabled: false,
  top: true,
  left: true,
  className: null,
  onClose: () => null,
};

MenuWrapper.contextTypes = {
  intl: intlShape,
  store: shape(),
};

export default MenuWrapper;
